"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaImageWrapper = void 0;
const react_1 = __importDefault(require("react"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const styles_1 = require("../../styles");
if ((0, monera_app_core_1.isClientSide)() && !(0, monera_app_core_1.isRunningInJest)()) {
    Promise.resolve().then(() => __importStar(require('lazysizes')));
}
const MediaImageWrapper = (props) => {
    const { mediaSrcUrl, lowResMediaSrcUrl, lazyLoad, id } = props;
    if (lazyLoad || lowResMediaSrcUrl) {
        const propsWithLazyAttrs = Object.assign(Object.assign({}, props), { 'data-src': mediaSrcUrl, src: lowResMediaSrcUrl ? lowResMediaSrcUrl : null });
        return react_1.default.createElement(styles_1.MediaImage, Object.assign({}, propsWithLazyAttrs, { id: id, className: 'lazyload' }));
    }
    return react_1.default.createElement(styles_1.MediaImage, Object.assign({}, props, { src: mediaSrcUrl, id: id }));
};
exports.MediaImageWrapper = MediaImageWrapper;
